import { ModelBase } from 'store/model-base';

export class CmsExchangeOrder extends ModelBase {
    public static storeName: string = 'cmsExchangeOrder';

    public header: string;
    public deviceNickname: string;
    public creditSummary: string;
    public chargeSummary: string;
    public downPaymentInfo: string;
    public paymentCharge: string;
    public paymentCredit: string;
    public exchangeIcon: CmsMediaImage;
    public orderItemDevice: CmsOrderItemDevice;
    public shipping: CmsShipping;
    public damageHeader: string;
    public restockHeader: string;
    public tax: CmsTax;
    public damageFeeAlertData: AlertModalData;
    public restockingFeeAlertData: AlertModalData;
}
